import { render, staticRenderFns } from "./TheRewardsTab.vue?vue&type=template&id=58d34544&"
import script from "./TheRewardsTab.vue?vue&type=script&lang=js&"
export * from "./TheRewardsTab.vue?vue&type=script&lang=js&"
import style0 from "./TheRewardsTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports